import {
  Box,
  ClickAwayListener,
  Divider,
  Paper,
  Popper,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useUserAction from "../../../../../hooks/user/useUserAction";
import useUserData from "../../../../../hooks/user/useUserData";

const LanguageMenu = ({ open, anchorEl, onClose }) => {
  const theme = useTheme();
  const { setUserLanguage } = useUserAction();
  const { language } = useUserData();

  const languages = [
    { code: "en", label: "EN" },
    { code: "el", label: "ΕΛ" },
  ];

  const handleLanguageSelect = (lang) => {
    setUserLanguage(lang);
    onClose();
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-end"
      sx={{
        zIndex: 1300,
      }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          sx={{
            mt: 0.7,
            width: "40px",
            borderRadius: "5px",
            backgroundColor: "#FCFCFC",
            overflow: "hidden",
            boxSizing: "border-box",
            border: "5px solid transparent",
            transition: "border 0.2s ease",
          }}
        >
          <Stack spacing={0} sx={{ width: "100%" }}>
            {languages.map((lang, index) => (
              <Box key={lang.code}>
                <Box
                  onClick={() => handleLanguageSelect(lang.code)}
                  sx={{
                    padding: "8px 0",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 900,
                      fontFamily: "'Zen Maru Gothic', Arial, sans-serif",
                      color:
                        language === lang.code
                          ? theme.palette.primary.main
                          : "#000000",
                    }}
                  >
                    {lang.label}
                  </Typography>
                </Box>

                {index < languages.length - 1 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "4px 0",
                      width: "100%",
                    }}
                  >
                    <Divider
                      variant="middle"
                      sx={{
                        backgroundColor: "#d0d0d0",
                        width: "50%",
                        borderColor: "divider",
                        borderRadius: 2,
                      }}
                    />
                  </Box>
                )}
              </Box>
            ))}
          </Stack>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default LanguageMenu;
